// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdfContainer[data-v-7eef9c26]{position:relative}.pdfContainer .desc[data-v-7eef9c26]{position:absolute;left:50%;top:50%;transform:translate(-50%,-300%);font-size:28px}", ""]);
// Exports
module.exports = exports;
